// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,\nbody,\n#app {\n  height: 100%;\n}\n\nbody {\n  background: rgb(var(--fc-background));\n}\n\n#app {\n  font-family: \"Open Sans\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.fa-icon {\n  width: auto;\n  height: 1em;\n  max-width: 100%;\n  max-height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
